import { autoAttributesPlugin } from '@growthbook/growthbook/plugins'
import { GrowthBook } from '@growthbook/growthbook-react'

import { FEATURE_FLAGS } from '~shared/constants'

import { IS_DEVELOPMENT_ENV, IS_PRODUCTION_ENV } from '~constants/config'

export const growthbook = new GrowthBook({
  apiHost: IS_DEVELOPMENT_ENV
    ? 'https://cdn.growthbook.io'
    : `${window.location.origin}/api/v1/proxy/growthbook`,
  clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: IS_DEVELOPMENT_ENV,
  plugins: [autoAttributesPlugin()],
})

// TODO(csat): remove once the CSAT flags exist in GrowthBook - testing
// override that forces both CSAT surfaces on in dev and staging.
if (!IS_PRODUCTION_ENV) {
  growthbook.setForcedFeatures(
    new Map([
      [FEATURE_FLAGS.RESPONDENT_CSAT, true],
      [FEATURE_FLAGS.ADMIN_CSAT, true],
    ]),
  )
}
